import React, { Component } from "react";

import WarningMessageStyles from "./WarningMessage.css";

/* eslint-disable import/no-webpack-loader-syntax */

import WarningIcon from "-!svg-react-loader!../images/Warning-2.svg";
import SuccessIcon from "-!svg-react-loader!../icons/success.svg";

class WarningMessage extends Component {
  render() {
    console.log(this.props.message);
    return this.props.message !== undefined &&
      this.props.message !== "" &&
      this.props.message !== null ? (
      <div className='warning-message' data-success={this.props.success}>
        {this.props.success ? <SuccessIcon /> : <WarningIcon />}
        <p dangerouslySetInnerHTML={{ __html: this.props.message }}></p>
      </div>
    ) : null;
  }
}

export default WarningMessage;



// WEBPACK FOOTER //
// ./src/components/WarningMessage.js